import styled from 'styled-components';
import { StyledCheckboxLabelProps } from './types';

export const StyledCheckboxLabel = styled.label<StyledCheckboxLabelProps>`
  display: flex;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : '')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: pointer;
`;

export const StyledCheckboxIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.125rem;
  height: 1.125rem;
  color: transparent;
  background-color: var(--surface);
  border-width: 1.5px;
  border-style: solid;
  border-color: rgba(9, 15, 56, 0.25);
  border-radius: var(--r-xs);
  transition: border-color 160ms ease, background-color 160ms ease;
  flex-shrink: 0;
  svg {
    width: 1em;
    height: 1em;
    font-size: 0.75rem;
    fill: currentColor;
  }

  &:hover {
    border-color: var(--brand-green);
  }
`;

export const StyledCheckbox = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
  :checked + ${StyledCheckboxIcon} {
    background-color: var(--brand-green);
    border-color: var(--brand-green);
    color: var(--surface);
  }
`;

export const StyledCheckboxLabelText = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 10px;
`;

export const StyledColorTag = styled.div<{ tagColor: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${(props) => props.tagColor};
`;
